import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import InputError from "@/Components/InputError";
import PatientLayout from "@/Layouts/PatientLayout";
import { PageProps } from "@/types";
import { Head, useForm } from "@inertiajs/react";
import { FormEventHandler } from "react";

type PinGateType = "document" | "article" | "video" | "podcast";

const PinGate = ({
    type,
    document_slug,
    article_slug,
    video_slug,
    podcast_series_slug,
    podcast_slug,
}: PageProps<{
    type: PinGateType;
    document_slug?: string;
    article_slug?: string;
    video_slug?: string;
    podcast_series_slug?: string;
    podcast_slug?: string;
}>) => {
    const { data, setData, post, processing, errors, transform } = useForm({
        confirmed: false,
        type: type || "document",
        document_slug: document_slug || "",
        article_slug: article_slug || "",
        video_slug: video_slug || "",
        podcast_series_slug: podcast_series_slug || "",
        podcast_slug: podcast_slug || "",
        // LEGACY PIN FLOW — keep for possible rollback
        // pin_code: "",
    });

    // FormData / Laravel `accepted` expects 1|0 more reliably than boolean
    transform((form) => ({
        ...form,
        confirmed: form.confirmed ? 1 : 0,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any);

    const submit: FormEventHandler = (e) => {
        e.preventDefault();
        if (!data.confirmed) {
            return;
        }
        post(route("front.patient.verifyPin"));
    };

    return (
        <PatientLayout>
            <Head title="Potwierdź dostęp do materiału" />
            <Container className="pt-24 pb-24">
                <Row className="justify-center">
                    <Column xl={6} lg={7} md={9}>
                        <div className="bg-deepIndigo/70 border-1 border-royalPeriwinkle rounded-2xl p-8">
                            <h1 className="text-arcticMist h4 font-semibold mb-3">
                                Uwaga
                            </h1>
                            <p className="text-arcticMist text-body mb-6">
                                Materiał jest przeznaczony wyłącznie dla pacjentów, którym lekarz
                                przepisał lek firmy Accord. Treści mają charakter edukacyjny i nie
                                zastępują porady lekarza, farmaceuty ani informacji zawartych w
                                ulotce dla pacjenta.
                            </p>

                            <form onSubmit={submit}>
                                <label className="flex items-start gap-x-4 cursor-pointer mb-6">
                                    <input
                                        type="checkbox"
                                        className="mt-1 size-5 shrink-0 rounded border-royalPeriwinkle bg-deepIndigo text-accordorange focus:ring-accordorange"
                                        checked={data.confirmed}
                                        onChange={(e) => setData("confirmed", e.currentTarget.checked)}
                                    />
                                    <span className="text-arcticMist text-body">
                                        Potwierdzam, że jestem pacjentem, któremu przepisano lek firmy
                                        Accord, i rozumiem, że materiał jest przeznaczony wyłącznie
                                        dla pacjentów stosujących zaleconą terapię.
                                    </span>
                                </label>
                                <InputError className="mt-2 mb-4" message={errors.confirmed} />

                                <button
                                    type="submit"
                                    disabled={processing || !data.confirmed}
                                    className="main-btn mt-2 w-full disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Przejdź do materiału
                                </button>

                                {/*
                                LEGACY PIN FLOW — uncomment + restore pin_code in useForm if needed
                                <TextInput
                                    id="pin_code"
                                    type="text"
                                    name="pin_code"
                                    className="w-full"
                                    placeholder="Wpisz 6-cyfrowy PIN"
                                    required
                                    maxLength={6}
                                    defaultValue={data.pin_code}
                                    onChange={(e) => setData("pin_code", e.currentTarget.value.replace(/\D/g, "").slice(0, 6))}
                                    icon="mdi:lock-outline"
                                />
                                <InputError className="mt-2" message={errors.pin_code} />
                                <button type="submit" disabled={processing} className="main-btn mt-6 w-full">
                                    Odblokuj materiał
                                </button>
                                */}
                            </form>
                        </div>
                    </Column>
                </Row>
            </Container>
        </PatientLayout>
    );
};

export default PinGate;
